import CityPageTemplate from "../city-template/CityPageTemplate";
import { watertownSDConfig } from "./data";

export default function WatertownSDPage() {
  return <CityPageTemplate config={watertownSDConfig} />;
}